<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Materials, Suppliers and Services

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">



        <ul class="nav nav-tabs nav-tab-service2 margin-top-13px" id="tabContent">
          <li class="active margin-right-15px"><a class="nav-itemerp active" href="#Vendor" data-toggle="tab">Add Vendor</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#Material" data-toggle="tab">Add Material</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#Materialtostore" data-toggle="tab">Add Material to Store</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#NewService" data-toggle="tab" *canUserAccess="['HL_ER_11']">S+</a></li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane active" id="Vendor">
            <div class="card">
              <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                <div class="row">
                  <div class="col-md-12 padding-l-0px">
                    <form class="form" novalidate="" (ngSubmit)="General()" #f="ngForm">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">

                          <div class="row">
                            <div class="col-md-12">


                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px"> Name </label>
                                    </div>
                                    <div class="col-md-8">

                                      <input type="text" class="form-control" placeholder="Name"
                                             id="CurrentSaveVendorInfoRequest.VendorName"
                                             [(ngModel)]="CurrentSaveVendorInfoRequest.VendorName"
                                             name="CurrentSaveVendorInfoRequest.VendorName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="100" minlength="1" #VName="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!VName.valid && (VName.dirty || VName.touched) && VName.errors.required )">(Field cannot be left blank)</small>
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!VName.valid && VName.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>

                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Mobile Phone </label>
                                    </div>
                                    <div class="col-md-3">
                                      <input type="tel" class="form-control" placeholder="Mobile Phone"
                                             id="CurrentSaveVendorInfoRequest.ContactNo"
                                             [(ngModel)]="CurrentSaveVendorInfoRequest.ContactNo"                                             
                                             name="CurrentSaveVendorInfoRequest.ContactNo" #phone1="ngModel">
                                      <!--<small class="form-text text-danger"
                                     *ngIf="(!phone1.valid && (phone1.dirty || phone1.touched) && phone1.errors.required )">(Field cannot be left blank)</small>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!phone1.valid)">(Provide Valid CellNo)</small>-->
                                    </div>
                                  </div>


                                </div>
                              </div>



                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-3 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Location</label>
                                    </div>

                                    <div class="col-md-3">
                                      <input type="text" class="form-control" placeholder="Location"
                                             id="CurrentSaveVendorInfoRequest.Location"
                                             [(ngModel)]="CurrentSaveVendorInfoRequest.Location"
                                             name="CurrentSaveVendorInfoRequest.Location" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" #Location="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Location.valid && (Location.dirty || Location.touched) && Location.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Location.valid && Location.errors.pattern)">(special characters are not allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>



                            </div>


                          </div>
                        </div>
                        <div class="card-footer">
                          <!--<button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>-->
                          <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="!f.form.valid" *ngIf='isvisiblev'>Save</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!--<div class="card-footer text-align-center">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
      </div>-->
            </div>


          </div>

          <div class="tab-pane" id="Material">

            <form class="form" novalidate="" (ngSubmit)="Education()" #fm="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Material Group</label>
                                </div>
                                <div class="col-md-8">
                                  <CustomDataByRequestType RequestedType="Material Groups " class="form-group" SelectedValue="StoreCode"
                                                           [(ngModel)]="MaterialGroupCode" (keyChange)="onAssignedToActorCodesurgeon2($event)"
                                                           name="MaterialGroupCodename" #sign2="ngModel">
                                  </CustomDataByRequestType>
                                  <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                         [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                         name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                          </CodeTypeValue>-->
                                  <!--<input type="text" class="form-control" placeholder="Test"
                                 id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                 name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                 maxlength="100" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                  <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                   id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                   [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                   name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                          </CustomDataByRequestType>-->
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px"> Name </label>
                                </div>
                                <div class="col-md-8">

                                  <input type="text" class="form-control" placeholder="Name"
                                         id="CurrentSaveMaterialDetailsInfoRequest.MaterialName"
                                         [(ngModel)]="CurrentSaveMaterialDetailsInfoRequest.MaterialName"
                                         name="CurrentSaveMaterialDetailsInfoRequest.MaterialName"
                                         maxlength="100" minlength="1" #Name="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Name.valid && (Name.dirty || Name.touched) && Name.errors.required )">(Field cannot be left blank)</small>
                                  <!--<small class="form-text text-danger"
                                         *ngIf="(!Name.valid && Name.errors.pattern)">(special characters are not allowed)</small>-->

                                </div>

                              </div>

                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Sell Unit </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Sell Unit"
                                         id="CurrentSaveMaterialDetailsInfoRequest.SellingUnit"
                                         [(ngModel)]="CurrentSaveMaterialDetailsInfoRequest.SellingUnit"
                                         name="CurrentSaveMaterialDetailsInfoRequest.SellingUnit" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #SellUnit="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!SellUnit.valid && (SellUnit.dirty || SellUnit.touched) && SellUnit.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!SellUnit.valid && SellUnit.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>



                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Purchase Unit</label>
                                </div>

                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Purchase Unit"
                                         id="CurrentSaveMaterialDetailsInfoRequest.PurchaseUnit"
                                         [(ngModel)]="CurrentSaveMaterialDetailsInfoRequest.PurchaseUnit"
                                         name="CurrentSaveMaterialDetailsInfoRequest.PurchaseUnit" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #PrUnit="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!PrUnit.valid && (PrUnit.dirty || PrUnit.touched) && PrUnit.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!PrUnit.valid && PrUnit.errors.pattern)">(special characters are not allowed)</small>


                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Hsn Code</label>
                                </div>

                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Hsn Code"
                                         id="CurrentSaveMaterialDetailsInfoRequest.HsnCode"
                                         [(ngModel)]="CurrentSaveMaterialDetailsInfoRequest.HsnCode"
                                         name="CurrentSaveMaterialDetailsInfoRequest.HsnCode" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #Hsncode="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Hsncode.valid && (Hsncode.dirty || Hsncode.touched) && Hsncode.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Hsncode.valid && Hsncode.errors.pattern)">(special characters are not allowed)</small>


                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Tax %</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="TAXPC" id="CurrentSaveMaterialDetailsInfoRequest.TaxPercentage"
                                                 [(ngModel)]="CurrentSaveMaterialDetailsInfoRequest.TaxPercentage" SelectedValue=""
                                                 name="CurrentSaveMaterialDetailsInfoRequest.TaxPercentage">
                                  </CodeTypeValue>
                                  <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                         [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                         name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                          </CodeTypeValue>-->
                                  <!--<input type="text" class="form-control" placeholder="Test"
                                 id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                 name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                 maxlength="100" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                  <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                   id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                   [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                   name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                          </CustomDataByRequestType>-->
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <!--<button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>-->
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="!fm.form.valid" *ngIf='isvisiblem'>Save</button>
                </div>
              </div>

            </form>





          </div>

          <div class="tab-pane" id="Materialtostore">

            <form class="form" novalidate="" #fms="ngForm">

              <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">
                          <div class="row margin-left-auto">
                            <div class="col-md-7 padding-right-0px border-right-3px-test">
                              <div class="row margin-top-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row margin-bottom-3px margin-right-0px">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">Selected Material</label>
                                    </div>:
                                    <div class="col-md-6 padding-right-0px">
                                      <h4 class="margin-bottom-0px margin-top-5px color-Assign font-weight-bold font-size-16px" *ngIf="SelectedMaterialDetails">{{SelectedMaterialDetails.MaterialName}}</h4>
                                      <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                   name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
    </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Test"
           id="CurrentSaveIvfCycleMedicineDataRequest.Form"
           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
           name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
           maxlength="100" required>
    <small class="form-text text-danger"
           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
    <small class="form-text text-danger"
           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                             id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
    </CustomDataByRequestType>-->

                                    </div>
                                    <div class="col-md-1 padding-left-5px" *canUserAccess="['HL_ER_AddMedToRX']">
                                      <button (click)="AddMedToGeneric(SelectedMaterialDetails.MaterialName)" name="addtogenric"
                                              class="btn font-size-10x actions-btn-prime margin-right-auto margin-left-5px">
                                        RX
                                      </button>

                                    </div>
                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">Store</label>
                                    </div>
                                    <div class="col-md-7">
                                      <CustomDataByRequestType RequestedType="AccessibleStores" FacilityCode={{FacilityCode}} ActorCode={{ActorCode2}} class="form-group" SelectedValue="StoreCode"
                                                               [(ngModel)]="StoreCode" (keyChange)="onAssignedStores($event)"
                                                               name="StoreCodename" #sign2="ngModel">
                                      </CustomDataByRequestType>
                                      <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                             [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                             name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                              </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Test"
                                     id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                     [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                     name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                     maxlength="100" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                       id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                       [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                       name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                              </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">Supplier</label>
                                    </div>
                                    <div class="col-md-7">
                                      <CustomDataByRequestType RequestedType="Vendors" FacilityCode={{FacilityCode}} ActorCode={{ActorCode2}} class="form-group" SelectedValue="StoreCode"
                                                               [(ngModel)]="SupplierCode" (keyChange)="onAssignedVendors($event)"
                                                               name="SupplierCodename" #sign2="ngModel">
                                      </CustomDataByRequestType>
                                      <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                             [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                             name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                              </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Test"
                                     id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                     [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                     name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                     maxlength="100" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                       id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                       [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                       name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                              </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Batch no</label>
                                    </div>

                                    <div class="col-md-7">
                                      <input type="text" class="form-control" placeholder="Batchno"
                                             id="CurrentSaveMaterialToStoreInfoRequest.BatchNo"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.BatchNo"
                                             name="CurrentSaveMaterialToStoreInfoRequest.BatchNo" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" required #Batchno="ngModel">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Batchno.valid && (Batchno.dirty || Batchno.touched) && Batchno.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Batchno.valid && Batchno.errors.pattern)">(special characters are not allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Batch Quantity</label>
                                    </div>

                                    <div class="col-md-7">
                                      <input type="text" class="form-control" placeholder="Batch Qunatity"
                                             id="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             name="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             maxlength="30" #Qunatity="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && (Qunatity.dirty || Qunatity.touched) && Qunatity.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && Qunatity.errors.pattern)">(only numbers are allowed)</small>


                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Entry Date</label>
                                    </div>

                                    <div class="col-md-7">

                                      <div class="date-form">
                                        <input type="text" class="form-control form-control-patient" placeholder="Date Of Birth"
                                               name="dp" [(ngModel)]="MfgDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d="ngbDatepicker" #DOBin="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOBin.valid && (DOBin.dirty || DOBin.touched) && DOBin.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Exp Date</label>
                                    </div>

                                    <div class="col-md-7">
                                      <div class="date-form">
                                        <input class="form-control form-control-patient" placeholder="Date Of Birth"
                                               name="dps" [(ngModel)]="ExpDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d1fe="ngbDatepicker" #DOBfe="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOBfe.valid && (DOBfe.dirty || DOBfe.touched) && DOBfe.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d1fe.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Purchase Price</label>
                                    </div>

                                    <div class="col-md-7">
                                      <input type="text" class="form-control" placeholder="Purchase Price"
                                             id="CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice"
                                             name="CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice"
                                             maxlength="30" #Pp="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pp.valid && (Pp.dirty || Pp.touched) && Pp.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pp.valid && Pp.errors.pattern)">(only numbers are allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Selling Price</label>
                                    </div>

                                    <div class="col-md-7">
                                      <input type="text" class="form-control" placeholder="Selling Price"
                                             id="CurrentSaveMaterialToStoreInfoRequest.SellingPrice"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.SellingPrice"
                                             name="CurrentSaveMaterialToStoreInfoRequest.SellingPrice"
                                             maxlength="30" #Sp="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Sp.valid && (Sp.dirty || Sp.touched) && Sp.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Sp.valid && Sp.errors.pattern)">(only numbers are allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">GST</label>
                                    </div>
                                    <div class="col-md-7">

                                      <CodeTypeValue CodeType="TAXPC" id="CurrentSaveMaterialToStoreInfoRequest.GST"
                                                     [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.GST" SelectedValue=""
                                                     name="CurrentSaveMaterialToStoreInfoRequest.GST" required>
                                      </CodeTypeValue>
                                      <!--<input type="text" class="form-control" placeholder="Test"
                                     id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                     [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                     name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                     maxlength="100" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                       id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                       [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                       name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                              </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="card">
                                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px  padding-t-6px padding-left-8px padding-right-0px font-size-16px">
                                  <div class="row">
                                    <div class="col-md-12">
                                      Materials
                                    </div>

                                  </div>
                                  <div class="row margin-top-5px margin-bottom-10px margin-left-0px">
                                    <div class="col-md-10 padding-left-0px display-inherit padding-right-0px">
                                      <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->

                                      <div class="clear-form">
                                        <input type="text" class="form-control width-230px" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                                        <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                                      </div>
                                      <button (click)="criteriaChange(searchValue)" name="search" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>

                                    </div>



                                  </div>
                                </div>
                                <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px margin-left-0px">

                                  <div class="chatsd product-chart-wrapper product-chat-material2 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                    <div class="table-component actor-table margin-bottom-0px">

                                      <div class="table-responsive overflow-x-hidden overflow-y-hidden">


                                        <table class="table table-striped table2">
                                          <tbody>
                                            <tr *ngFor="let l of CurrentMaterialsListController">
                                              <td class="td-padding-2px">

                                                <div class="row margin-left-zero margin-right" (click)="SelectedMaterial(l)">
                                                  <div class="col-md-1  margin-top-3px padding-right-0px padding-left-0px">
                                                    <button type="button"
                                                            class="btn  btn-sm plus-button " id="FileUpload"
                                                            name="upload">
                                                      <i class="fas fa-plus font-size-11p"></i>
                                                    </button>

                                                  </div>
                                                  <div class="col-md-10 margin-tb-auto padding-left-10px">
                                                    <label class="margin-bottom-0px color3 font-size-12px">{{l.MaterialName}}</label>
                                                    <!--<a *canUserAccess="['HL_ER_13']"                                                       
                                                       class="nav-link-hand font-size-16px color-Rejected" title="Remove">
                                                      <i class="far fa-trash-alt nav-link-hand"></i>
                                                    </a>-->
                                                  </div>
                                                </div>


                                              </td>
                                            </tr>

                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>




                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <!--<button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>-->
                  <button (click)="Registration()" name="forsave" class="btn actions-btn-prime float-right font-size-13px" [disabled]="Batchno.errors?.required || Qunatity.errors?.required || Pp.errors?.required || Sp.errors?.required" *ngIf='isvisiblemts'>Save</button>
                </div>
              </div>

            </form>



          </div>

          <div class="tab-pane" id="NewService">

            <form class="form" novalidate="" (ngSubmit)="AddService()" #fm2="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Name </label>
                                </div>
                                <div class="col-md-8">

                                  <!--<input type="text" class="form-control" placeholder="Service Name"
                                         id="CurrentSaveNewServiceRequest.ServiceName"
                                         [(ngModel)]="CurrentSaveNewServiceRequest.ServiceName"
                                         name="CurrentSaveNewServiceRequest.ServiceName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="140" minlength="1">-->
                                  <textarea class="form-control3 size-2 width-inherit"
                                            rows="2" placeholder="Service Name"
                                            name="CurrentSaveNewServiceRequest.ServiceName"
                                            [(ngModel)]="CurrentSaveNewServiceRequest.ServiceName"
                                            maxlength="140" minlength="1"></textarea>
                                </div>

                              </div>

                            </div>
                          </div>
                          <!--<div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-3 text-align-right padding-left-0px">
          <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Group</label>
        </div>
        <div class="col-md-3">
          <CustomDataByRequestType RequestedType="Material Groups " class="form-group" SelectedValue="StoreCode"
                                   [(ngModel)]="MaterialGroupCode" (keyChange)="onAssignedToActorCodesurgeon2($event)"
                                   name="MaterialGroupCodename" #sign2="ngModel">
          </CustomDataByRequestType>
        </div>

      </div>

    </div>
  </div>-->
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Department Code</label>
                                </div>
                                <div class="col-md-6">
                                  <CustomDataByRequestType RequestedType="Departments List" class="form-group" FacilityCode={{FacilityCode}}
                                                           [(ngModel)]="CurrentSaveNewServiceRequest.DepartmentCode" (keyChange)="Department($event)"
                                                           name="CurrentSaveNewServiceRequest.DepartmentCode" #DepartmentsList="ngModel">
                                  </CustomDataByRequestType>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Category Code</label>
                                </div>
                                <div class="col-md-6">
                                  <CustomDataByRequestType RequestedType="Service Category list" class="form-group" FacilityCode={{FacilityCode}}
                                                           [(ngModel)]="CurrentSaveNewServiceRequest.ServiceCategoryCode" (keyChange)="ServiceCategory($event)"
                                                           name="CurrentSaveNewServiceRequest.ServiceCategoryCode" #ServiceCategoryCode="ngModel">
                                  </CustomDataByRequestType>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Revenue Category Code</label>
                                </div>
                                <div class="col-md-6">
                                  <CodeTypeValue CodeType="REVCT" id="CurrentSaveNewServiceRequest.RevenueCategoryCode"
                                                 [(ngModel)]="CurrentSaveNewServiceRequest.RevenueCategoryCode"
                                                 name="CurrentSaveNewServiceRequest.RevenueCategoryCode">
                                  </CodeTypeValue>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Type</label>
                                </div>
                                <div class="col-md-6">
                                  <CodeTypeValue CodeType="GSVCT" id="CurrentSaveNewServiceRequest.ServiceType"
                                                 [(ngModel)]="CurrentSaveNewServiceRequest.ServiceType"
                                                 name="CurrentSaveNewServiceRequest.ServiceType">
                                  </CodeTypeValue>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Point</label>
                                </div>
                                <div class="col-md-6">
                                  <CodeTypeValue CodeType="Servi" id="CurrentSaveNewServiceRequest.ServicePoint"
                                                 [(ngModel)]="CurrentSaveNewServiceRequest.ServicePoint"
                                                 name="CurrentSaveNewServiceRequest.ServicePoint">
                                  </CodeTypeValue>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Price </label>
                                </div>
                                <div class="col-md-6">
                                  <input type="text" class="form-control" placeholder="Price"
                                         id="CurrentSaveNewServiceRequest.Price"
                                         [(ngModel)]="CurrentSaveNewServiceRequest.Price"
                                         name="CurrentSaveNewServiceRequest.Price" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #Price="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Price.valid && (Price.dirty || Price.touched) && Price.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Price.valid && Price.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>



                          <!--<div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

      <div class="row">
        <div class="col-md-3 text-align-right">
          <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Branch</label>
        </div>

        <div class="col-md-3">
          <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode}}
                                   (keyChange)="Branchdata($event)"
                                   [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                   required>
          </CustomDataByRequestType>
        </div>
      </div>


    </div>
  </div>-->
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Is Price Editable</label>
                                </div>

                                <div class="col-md-3">
                                  <input type="checkbox" [(ngModel)]="CurrentSaveNewServiceRequest.IsPriceEditable"
                                         class="width-15px" name="CurrentSaveNewServiceRequest.IsPriceEditable">
                                </div>
                              </div>


                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="!fm2.form.valid" *ngIf='isvisiblem'>Save</button>
                </div>
              </div>

            </form>





          </div>







        </div>



      </div>

    </div>
  </div>
</div>
